import { Component, OnInit } from '@angular/core';
import { ReclamacionesService } from '../../services/reclamaciones.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ErrorHelper } from '../../models/ErrorHelper';
import { AuthService } from '../../services/auth.service';
import { LocalizationService } from '../../services/localization.service';
import * as $ from 'jquery';
import { DateHelper } from '../../models/NgDateCustomAdapter';
import { ReclamacionModel } from '../../models/Reclamacion';
import { TasacionReclamacionEditComponent } from '../tasacion-reclamacion-edit/tasacion-reclamacion-edit.component';
import { ModelHelpers } from '../../models/ModelHelpers';
import { MatDialog, MatDialogConfig } from '@angular/material';

@Component({
  selector: 'app-reclamaciones-edit',
  templateUrl: './reclamaciones-edit.component.html',
  styleUrls: ['./reclamaciones-edit.component.scss']
})
export class ReclamacionesEditComponent implements OnInit {

  formGroup: FormGroup;
  model: any;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  errorMessage: any = '';

  activoCierre = true;

  localization: LocalizationService;
  options: any = {
    format: 'DD/MM/YYYY'
  };

  tasacionInfo: any = {
    id:  '',
    cliente: '',
    entidad: '',
    ciudad: ''
  };

  tipoIncidenciaList: any[] = [
    { id: 1, displayName: "Faltan aspectos acordados" },
    { id: 2, displayName: "Nuevos requerimientos" },
    { id: 3, displayName: "Errores técnicos" },
    { id: 4, displayName: "Revisión de valor" },
    { id: 5, displayName: "Explicaciones" },
    { id: 99, displayName: "Otros" }];

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, localization: LocalizationService,
    private _ReclamacionService: ReclamacionesService, private _authService: AuthService,
    private _router: Router, public dateHelper: DateHelper, public matDialog: MatDialog) {

    this.localization = localization;

    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    } else {
      this.id = 0;
    }

    this.initForm();

  }

  ngOnInit() {


  }

  initForm() {
    this.formGroup = this._fb.group({
      id: 0,
      actuacionRealizada: ['', Validators.required],
      detalle: ['', Validators.required],
      solucionReclamacion: [{ value: '', disabled: !(this._authService.authDataCache.admin || this._authService.authDataCache.gestor) }],
      tasacionID: [{value: '', disabled: true}, Validators.required],
      fechaInicio: [this.dateHelper.dateFormat_iso(new Date())],
      fechaFin: [{ value: '', disabled: true }],
      tipoMotivo:0
    });

    if (this._avRoute.snapshot.params['tasacion']) {
      this.formGroup.get('tasacionID').setValue(this._avRoute.snapshot.params['tasacion']);
    }

    if (this.id > 0) { 
      
      this.isNewElement = false;
      this.title = 'Editar';
      this._ReclamacionService.getById(this.id)
        .subscribe((resp: any) => {
          this.model = resp;
          if (resp.estado === 'Error') {
            this._router.navigate(['/reclamaciones']);
          }
          this.formGroup.patchValue(resp);
          if (this.model.fechaFin === null) {
            this.activoCierre = true;
          } else {
            this.activoCierre = false;
          }

          this._ReclamacionService.getTasacionID(this.formGroup.get('tasacionID').value).subscribe(data => this.tasacionInfo = data);
        }, error => { this.errorMessage = error; this.back(); });
    } else {
      this.isNewElement = true;
      this._ReclamacionService.getTasacionID(this.formGroup.get('tasacionID').value).subscribe(data => this.tasacionInfo = data);
      this.activoCierre = true;
    }

  }

  back() {
    this._router.navigate(['/reclamaciones']);
  }

  save() {

    if (!this.formGroup.valid) {
      return;
    }

    if (this.isNewElement) {
      this._ReclamacionService.create(this.formGroup.getRawValue())
        .subscribe((data: any) => {
          if(data.estado == 'Error') {
            this.errorMessage = data.mensaje;
          }
          this._router.navigate(['/tasacion/edit/' + this.tasacionInfo.id]);
        }, error => {
          this.errorMessage = ErrorHelper.GetClientError(error);
        }
        );
    } else {
      this._ReclamacionService.update(this.id, this.formGroup.getRawValue())
        .subscribe((data: any) => {
          if (data.estado === 'Correcto') {
            this._router.navigate(['/tasacion/edit/' + this.tasacionInfo.id]);
            
          } else {
            this.errorMessage = data.mensaje;
          }
        }, error => {
            this.errorMessage = ErrorHelper.GetClientError(error);
          });
    }
  }

  public moment(data) {
    if (data == null || data === '') {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY');
  }

  public volverReclamaciones() {
    this._router.navigate(['/reclamaciones-abiertas']);
  }

  public volverTasacion(tasacion: number) {
    this._router.navigate(['/tasacion/edit/' + tasacion]);
  }

  get actuacionRealizada() { return this.formGroup.get('actuacionRealizada'); }
  get detalle() { return this.formGroup.get('detalle'); }

  closeReclamacion() {
    const dialogConfig = new MatDialogConfig();
    let reclamacionModel = new ReclamacionModel();
    ModelHelpers.copyFromForm(this.formGroup.value, reclamacionModel);
    dialogConfig.width = "700px"
    dialogConfig.data = {
      id: this.tasacionInfo.id,
      model: reclamacionModel
    }
    let dlgRef = this.matDialog.open(TasacionReclamacionEditComponent, dialogConfig);
    dlgRef.afterClosed().subscribe(result => {
      if (result) {
        this._router.navigate(['/tasacion/edit/' + this.tasacionInfo.id]);
      }
    })
  }
}
